<div class="color-picker-square" [formGroup]="formGroup">
  <label *ngIf="label" class="color-picker-square__label" [attr.for]="inputId || null">{{ label }}</label>
  <input
    class="color-picker-square__input"
    type="color"
    [attr.id]="inputId || null"
    [attr.aria-label]="ariaLabel || label || 'Color'"
    [formControlName]="controlName"
  />
  <span *ngIf="hint" class="color-picker-square__hint">{{ hint }}</span>
</div>